import "./PartnersGallery.scss"
import React from "react"
import Image from "gatsby-image"
import { Container, Row, Col } from "reactstrap"

import {
  extractAltTag
} from "@utils/utils"

const PartnersGallery = ({ images, ...props }) => (
  <Container id="partners-gallery" className="mt-n5" {...props}>
    <Row>
      <Col className="p-4">
        <Image fluid={images[0]} alt={extractAltTag(images[0].src, 'Partner')} />
      </Col>
      <Col className="p-4">
        <Image fluid={images[1]} alt={extractAltTag(images[1].src, 'Partner')} />
      </Col>
      <Col className="p-4">
        <Image fluid={images[2]} alt={extractAltTag(images[2].src, 'Partner')} />
      </Col>
    </Row>
    <Row>
      <Col className="p-4">
        <Image fluid={images[3]} alt={extractAltTag(images[3].src, 'Partner')} />
      </Col>
      <Col className="p-4">
        <Image fluid={images[4]} alt={extractAltTag(images[4].src, 'Partner')} />
      </Col>
      <Col className="p-4">
        <Image fluid={images[5]} alt={extractAltTag(images[5].src, 'Partner')} />
      </Col>
      <Col className="p-4">
        <Image fluid={images[6]} alt={extractAltTag(images[6].src, 'Partner')} />
      </Col>
    </Row>
  </Container>
)

export default PartnersGallery
